import { useEffect, useState } from 'react'

import { useCubeReportPageFiltersContext } from 'cube'
import { CONVERSATION_FACTS_DIMENSIONS } from 'cube/constants/QueryConstants'
import { RoutingSankeyQuery } from 'cube/queries'

import { CubeQueryBuilder, useCubeQuery } from '@driftt/dds.reports'

import useTimePeriod from 'hooks/useTimePeriod'

import {
  resolveHasAtLeastOneEdgeWithData,
  resolveSankeyData,
} from './RoutingSankey.helpers'

/***
 * Hook that cube to fetch sankey data
 *
 * @returns object
 */
export const useRoutingSankey = (): {
  data: any
  isLoading: boolean
} => {
  const [formattedData, setFormattedData] = useState<any>()
  const timePeriod = useTimePeriod()
  const { pageFilters } = useCubeReportPageFiltersContext()

  const cubeQuery = new CubeQueryBuilder({ query: RoutingSankeyQuery })
    .withinDateRange(
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_CREATED_AT,
      timePeriod.startDate.toDate(),
      timePeriod.endDate.toDate()
    )
    .withFilters(pageFilters)
    .build()

  const { data, isInitialLoading } = useCubeQuery({ query: cubeQuery })

  useEffect(() => {
    if (data) {
      const pivot = data.tablePivot()

      if (resolveHasAtLeastOneEdgeWithData(pivot)) {
        setFormattedData(resolveSankeyData(pivot))
      } else {
        setFormattedData([])
      }
    }
  }, [data])

  return {
    data: formattedData,
    isLoading: isInitialLoading,
  }
}

export default useRoutingSankey
